export default "__VITE_ASSET__DySL2vFN__"